// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__PmbN8","rotate":"Spinner_rotate__z7pGg","small":"Spinner_small__4Ugdw","medium":"Spinner_medium__n1QbQ","large":"Spinner_large__pnGsR"};
    if(module.hot) {
      // 1763464084384
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  